var map = {
	"./action.svg": 15701,
	"./check.svg": 98807,
	"./close.svg": 95242,
	"./compass.svg": 39413,
	"./facebook.svg": 95612,
	"./glasses.svg": 1671,
	"./goal.svg": 80794,
	"./goals.svg": 26734,
	"./identity.svg": 72417,
	"./linkedin.svg": 27527,
	"./list.svg": 72247,
	"./star.svg": 17146,
	"./twitter.svg": 26537,
	"./youtube.svg": 61282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91529;